$(function() {
  $('[data-push-state]').on('click', function() {
    window.history.pushState(null, null, $(this).data('push-state'));
  });
});
